import { getInstance } from "./authWrapper";
import AuthBehavior from "@/mixins/AuthBehavior";
import store from "@/store"; // Import the Vuex store

export const authGuardWithPermission = (requiredPermission) => async (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    try {
      if (authService.isAuthenticated) {
        const context = {$store: store};
        await context.$store.dispatch('getAuthUser');
        if (!context.$store.state.patients.authUser || !context.$store.state.patients.authUser.behaviors) {
          await context.$store.dispatch('getAuthUser');
        }
        const authUser = context.$store.state.patients.authUser;

        if (AuthBehavior.methods.hasPermission(authUser, requiredPermission)) {
          return next();
        } else {
          return next({name: 'access-denied'});
        }
      }
    } catch (e) {
      return next({name: 'access-denied'});
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};